import { useNavigate } from "react-router-dom";
import { FiDollarSign, FiCreditCard } from "react-icons/fi";

const Fees = () => {
  const navigate = useNavigate();

  const fees = [
    {
      type: "Transport Fee",
      amount: "₹3,000",
    },
    {
      type: "Examination Fee",
      amount: "₹1,500",
    },
    {
      type: "Tuition Fee",
      amount: "₹25,000",
    },
  ];

  return (
    <div className="w-full space-y-6">
      {/* 🌟 Header Banner */}
      <div className="bento-header-banner flex items-center justify-between">
        <div>
          <h1 className="text-xl md:text-2xl font-bold tracking-tight flex items-center gap-2 text-slate-900 dark:text-white">
            <FiCreditCard className="text-indigo-600 dark:text-indigo-400" />
            <span>Fee Payment Portal</span>
          </h1>
          <p className="text-xs md:text-sm text-slate-500 dark:text-slate-400 mt-1">Review outstanding academic balances & process secure online payments</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {fees.map((fee, index) => (
          <div
            key={index}
            className="bg-white dark:bg-slate-900 shadow-xs dark:shadow-xl rounded-2xl p-6 flex flex-col items-center justify-between border border-slate-200 dark:border-slate-800 hover:border-indigo-500/50 transition-all space-y-4"
          >
            <div className="w-12 h-12 rounded-xl bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 flex items-center justify-center border border-indigo-100 dark:border-indigo-500/20">
              <FiDollarSign className="w-6 h-6" />
            </div>
            <h3 className="text-base font-bold text-slate-900 dark:text-white">{fee.type}</h3>
            <p className="text-3xl font-black text-indigo-600 dark:text-indigo-400">{fee.amount}</p>
            <button
              onClick={() => navigate("/payment")}
              className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs py-2.5 rounded-xl transition-all shadow-md shadow-indigo-600/20 cursor-pointer"
            >
              Pay Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Fees;
